/* eslint-disable better-mutation/no-mutation */

import config from './config';
import eventBroadcaster from './event-broadcaster';
import scribe from './scribe';
import { logger } from 'packages/logger';
import axios from 'axios';

export default new (function () {
    var allowedFileExtensions = ['.jpeg', '.jpg', '.png', '.gif'];
    var maxFileSize = 1024 * 1024 * 20;

    this.isMultifileSupported = function () {
        return typeof window.FormData !== 'undefined';
    };

    this.uploadFiles = function (files, maxNumberOfFiles, imageFlow) {
        for (let i = 0; i < files.length && i < maxNumberOfFiles; i++) {
            const file = files[i];
            var validationResult = validateFile(file);
            if (validationResult) {
                notifyImageValidationFailed(validationResult);
                return;
            }
        }
        for (let i = 0; i < files.length && i < maxNumberOfFiles; i++) {
            const file = files[i];
            uploadFileWithFormData(file, imageFlow);
        }
    };

    this.uploadFromFileInput = function (
        fileInput,
        maxNumberOfFiles,
        imageFlow
    ) {
        if (typeof window.FormData === 'undefined') {
            uploadFileWithDom(fileInput, imageFlow);
            fileInput.value = '';
        } else {
            for (
                var i = 0;
                i < fileInput.files.length && i < maxNumberOfFiles;
                i++
            ) {
                var file = fileInput.files[i];
                var validationResult = validateFile(file);
                if (validationResult) {
                    fileInput.value = '';
                    notifyImageValidationFailed(validationResult);
                    return;
                }
            }
            for (
                let i = 0;
                i < fileInput.files.length && i < maxNumberOfFiles;
                i++
            ) {
                const file = fileInput.files[i];
                uploadFileWithFormData(file, imageFlow);
            }
            fileInput.value = '';
        }
    };

    this.uploadCroppedImageFile = async function (
        imageFile,
        imageFlow,
        slotIndex
    ) {
        if (imageFile.type && imageFile.type.startsWith('image/')) {
            var validationResult = validateFile(imageFile);
            if (validationResult) {
                notifyImageValidationFailed(validationResult);
                return;
            }
            return uploadFileWithFormData(imageFile, imageFlow, slotIndex);
        }
    };

    async function uploadFileWithFormData(file, imageFlow, replaceIndex) {
        const startTime = new Date().getTime();
        var formData = new FormData();
        formData.append('imageFile', file);

        const url = config[imageFlow + 'ImagesUrl'];
        try {
            const response = await axios.post(url, formData);
            if (response.data.errorCode) {
                handleErrorCode(response.data.errorCode);
                return;
            }
            notifyImageUploaded(
                response.data.imageId,
                response.data.imageUrl,
                replaceIndex
            );
            const endTime = new Date().getTime();
            scribe.sendDuration(
                'image_upload_client_time',
                endTime - startTime
            );
        } catch (error) {
            if (error.response) {
                notifyImageUploadFailed(file);
            } else if (error.request) {
                // The request was made but no response was received
                notifyImageUploadFailed(file);
                logger('Image upload failed. Reason: No response');
            } else {
                // Something happened in setting up the request that triggered an Error
                notifyImageUploadFailed(file);
                logger('Image upload failed. Reason: ' + error.message);
            }
        }
    }

    function handleErrorCode(errorCode) {
        if (errorCode === 'ImageMinimumDimensionsNotReached') {
            notifyImageValidationFailed(
                'syi_validation_images_upload_too_small'
            );
        }
    }

    function uploadFileWithDom(fileInput, imageFlow) {
        var iframe_name = 'iframe_' + new Date().getTime();
        var iframe = document.createElement('iframe');
        var form = document.createElement('form');
        var input = document.createElement('input');
        form.setAttribute('name', 'upload_form');
        form.setAttribute('id', 'upload_form');
        form.setAttribute('style', 'height: 0px;');
        form.setAttribute('method', 'post');
        form.setAttribute('action', config[imageFlow + 'ImagesUrl']); // e.g. "draft" + "ImagesUrl"
        form.setAttribute('enctype', 'multipart/form-data');
        form.setAttribute('target', iframe_name);
        input.setAttribute('type', 'hidden');
        input.setAttribute('name', 'iframe');
        input.setAttribute('value', 'true');
        iframe.setAttribute('name', iframe_name);
        iframe.setAttribute('style', 'height: 0px;');
        iframe.setAttribute('id', iframe_name);

        form.appendChild(input);

        var fileInputParent = fileInput.parentNode;
        form.appendChild(fileInput);

        document.body.appendChild(iframe);
        document.body.appendChild(form);
        form.submit();

        fileInputParent.appendChild(fileInput); // Restore input node
        document.body.removeChild(form);

        // Only one file is supported using this method.
        var theFile = fileInput.value;

        iframe.onload = function (e) {
            try {
                var responseText = $(
                    e.target.contentDocument.body.innerHTML
                ).text();
                var response = $.parseJSON(responseText);
                notifyImageUploaded(response.imageId, response.imageUrl);
            } catch (err) {
                notifyImageUploadFailed(theFile);
                logger('Image upload with DOM failed.');
                fileInput.value = '';
            }

            document.body.removeChild(iframe);
        };
    }

    function endsWith(str, suffix) {
        return str.indexOf(suffix, str.length - suffix.length) !== -1;
    }

    function hasValidFileExtension(filename) {
        return allowedFileExtensions.some((fileExt) =>
            endsWith(filename.toUpperCase(), fileExt.toUpperCase())
        );
    }

    function hasValidFileSize(fileSize) {
        return fileSize < maxFileSize;
    }

    function validateFile(file) {
        if (file === undefined) {
            return 'syi_validation_images_upload_error'; //'Något blev fel vid uppladdningen av filen';
        }
        if (!hasValidFileExtension(file.name)) {
            return 'syi_validation_images_upload_wrong_type'; //'Filen du laddade upp är av fel typ.';
        }
        if (!hasValidFileSize(file.size)) {
            return 'syi_validation_images_upload_too_large'; //'Filen du laddade upp är för stor.';
        }
        return false;
    }

    function notifyImageUploaded(imageId, imageUrl, replaceIndex) {
        eventBroadcaster.trigger(
            'imageUploaded',
            imageId,
            imageUrl,
            replaceIndex
        );
    }

    function notifyImageUploadFailed(file) {
        eventBroadcaster.trigger('imageUploadFailed', file);
    }

    function notifyImageValidationFailed(displayMessage) {
        eventBroadcaster.trigger('imageValidationFailed', displayMessage);
    }
})();
